import tools from '@/utils/tools';

//获取菜单接口
const getList = async function(params,that){
  var url = "/backend/users/list.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取权限接口
const getPowerList = async function(params,that){
  var url = "/backend/roles/getPowerList.html";
  const res = await tools.post(url,params,that);
  return res
}

//添加用户接口
const addUser = async function(params,that){
  var url = "/backend/users/addUser.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取用户接口
const getUser = async function(params,that){
  var url = "/backend/users/getUser.html";
  const res = await tools.post(url,params,that);
  return res
}

//编辑用户接口
const editUser = async function(params,that){
  var url = "/backend/users/editUser.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除用户接口
const delUser = async function(params,that){
  var url = "/backend/users/delUser.html";
  const res = await tools.post(url,params,that);
  return res
}

//修改密码接口
const changePassword = async function(params,that){
  var url = "/backend/users/changePassword.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取供应商接口
const getSupplier = async function(params,that){
  var url = "/backend/users/getSupplier.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取子公司接口
const getsubsidiary = async function(params,that){
  var url = "/backend/users/getsubsidiary.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取子公司接口
const getCompany = async function(params,that){
  var url = "/backend/users/getCompany.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取供应商接口
const getBuyer = async function(params,that){
  var url = "/backend/users/getBuyer.html";
  const res = await tools.post(url,params,that);
  return res
}

//导出接口
const exportMember = async function(params,that){
  var url = "/backend/users/exportMember.html";
  const res = await tools.post(url,params,that);
  return res
}

const examineAlluser = async function(params,that){
  var url = "/backend/users/examineAll.html";
  const res = await tools.post(url,params,that);
  return res
}

const userFunction = {
  getList,
  getPowerList,
  addUser,
  getUser,
  editUser,
  delUser,
  changePassword,
  getSupplier,
  getsubsidiary,
  getCompany,
  getBuyer,
  exportMember,
  examineAlluser,
}

export default userFunction;


// WEBPACK FOOTER //
// ./src/api/user.js